import userInfo from 'hub-http/userInfo';
import PortalIdParser from 'PortalIdParser';
import { createAsyncThunk, createReducer } from '@reduxjs/toolkit';
export const getAuth = createAsyncThunk('getAuth', () => {
  PortalIdParser.get();
  return userInfo();
});
const initialState = {};
const authReducer = createReducer(initialState, builder => {
  builder.addCase(getAuth.fulfilled, (state, action) => {
    return action.payload;
  });
});
export default authReducer;